<template>
  <div id="survey-visualized">
    <loading :active.sync="loading"></loading>

    <!-- Card -->
    <b-card class="mx-auto px-4"
            v-if="!loading && slide"
            :style="{ 'min-height': currentUser ? '100%' : '100vh' }">
      <!-- Card header -->
      <template #header>
        <b-container fluid>
          <!-- Title -->
          <b-row class="survey-title"
                 v-if="page">
            <b-col>
              <span>{{ page.title }}</span>
            </b-col>
            <!-- new Nav -->
            <b-col>
              <div class="text-right">
                <b-dropdown v-if="categoryNav.length>0" id="dropdown-1" text="Category" class="m-md-2">
                  <b-dropdown-item v-for="slide in categoryNav"
                                 :key="slide.page"
                                 @click="setPage(slide.page)">
                  {{ slide.category }}
                </b-dropdown-item>
                </b-dropdown>
              </div>
            </b-col>
<!-- /new Nav -->
          </b-row>
          <!-- /Title -->
        </b-container>
      </template>
      <!-- /Card header -->

      <!-- Card body -->
      <template #default
                v-if="page">
        <b-container fluid>
          <!-- Description -->
          <b-row class="mb-3">
            <b-col class="column">
              <b-form-textarea plaintext
                               :value="page.description"
                               style="font-size:1.4rem;"></b-form-textarea>
            </b-col>
          </b-row>
          <!-- /Description -->

          <!-- Chart and table -->
          <survey-tendency-comparison-grid
            v-if="page.category === '직원성향'"
            :slide="page"/>
          <survey-tendency-comparison-by-employee-journey-grid
            v-else-if="page.option === '직원성향'"
            :slide="page"/>
          <survey-base-grid v-else
                            :slide="page"/>
          <!-- /Chart and table -->

          <!-- Footnote -->
          <b-row v-if="page.footNote">
            <b-col class="column">
              <b-form-textarea class="footnote"
                               plaintext
                               :value="page.footNote"></b-form-textarea>
            </b-col>
          </b-row>
          <!-- /Footnote -->

          <!-- navigation arrows -->
          <b-icon class="h1 arrow arrow-left"
                  icon="chevron-left"
                  variant="secondary"
                  @click="goLeft"
                  v-if="slides && curr > 1"></b-icon>
          <b-icon class="h1 arrow arrow-right"
                  icon="chevron-right"
                  variant="secondary"
                  @click="goRight"
                  v-if="slides && curr < total"></b-icon>
          <!-- /navigation arrows -->
        </b-container>
      </template>
      <!-- /Card body -->

      <!-- Card footer -->
      <template #footer>
        <!-- Pagination -->
        <b-pagination class="mb-0"
                      v-model="curr"
                      :total-rows="total"
                      per-page="1"
                      limit="10"
                      align="center"></b-pagination>
        <!-- /Pagination -->
      </template>
      <!-- /Card footer -->
    </b-card>
    <!-- /Card -->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import SurveyBaseGrid from "@/components/survey/SurveyBaseGrid.vue";
import SurveyTendencyComparisonGrid from "@/components/survey/SurveyTendencyComparisonGrid.vue";
import SurveyTendencyComparisonByEmployeeJourneyGrid
  from "@/components/survey/SurveyTendencyComparisonByEmployeeJourneyGrid.vue";
import store from "@/store/index";

export default ({
  props: ['id', 'secret'],
  components: { Loading, SurveyBaseGrid, SurveyTendencyComparisonGrid, SurveyTendencyComparisonByEmployeeJourneyGrid },
  async beforeRouteEnter(to, from, next) {
    if (to.name === "surveyVisualizedSecret") {
      let response = await axios.post("/survey/selectSurveyDetail/" + to.params.secret);
      if (response.data == null || response.data === "") {
        next("/signin");
        store.commit("setMessage", "만료된 주소입니다. 담당자에게 문의해주세요.");
      } else if (response.data !== to.params.id) {
        next("/signin");
        store.commit("setMessage", "정확하지 않은 주소입니다.");
      } else {
        next()
      }
    } else {
      next()
    }
  },
  data() {
    return {
      loading: false, // Loading indicator
      curr: 1, // Current slide index
      slides: [], // Slide details
      selectedQuestion: null, // 선택된 문항
      selectedEmployeeJourney: null, // 선택된 직원여정
      comparisonPages: {},
      categoryNav : [],
      questions: {
        "직원성향": { order: 1 },
        "객관식": { order: 2 },
        "체크리스트": { order: 3 },
        "서술형": { order: 4 },
      },
      employeeJourneys: {
        "응답현황": { order: 1 },
        "직원성향": { order: 2 },
        "Recruitment": { order: 3 },
        "Onboarding": { order: 4 },
        "Engagement& Development": { order: 5 },
        "Performance&Reward": { order: 6 },
        "Overall": { order: 7 },
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    total() {
      return this.slides.length;
    },
    slide() {
      return this.slides[this.curr - 1];
    },
    page() {
      if (this.slide.category === '차수비교') {
        return this.selectedQuestion ?
          this.slide.pages[this.selectedEmployeeJourney][this.selectedQuestion] :
          this.slide.pages[this.selectedEmployeeJourney];
      }
      return this.slide;
    },
    employeeJourneyOptions() {
      if (this.slide && this.slide.category === '차수비교') {
        let employeeJourneys = this.employeeJourneys;
        let options = Object.keys(this.slide.pages);
        options.sort((a, b) => {
          if (employeeJourneys[a] && employeeJourneys[b]) {
            return employeeJourneys[a].order - employeeJourneys[b].order;
          } else {
            return 0;
          }
        });
        return options;
      }
      return null
    },
    questionOptions() {
      if (this.slide && this.slide.category === '차수비교') {
        if (this.selectedEmployeeJourney &&
          this.selectedEmployeeJourney !== '직원성향' &&
          this.selectedEmployeeJourney !== '응답현황') {
          let questions = this.questions;
          let options = Object.keys(this.slide.pages[this.selectedEmployeeJourney]);
          options.sort((a, b) => questions[a].order - questions[b].order);
          return options;
        }
        return [];
      }
      return null;
    },
  },
  methods: {
    goLeft() {
      if (this.slides)
        this.curr = Math.max(1, this.curr - 1);
    },
    goRight() {
      if (this.slides)
        this.curr = Math.min(this.total, this.curr + 1);
    },
    handleArrowKey(event) {
      if (event.key === 'ArrowLeft') {
        this.goLeft();
      } else if (event.key === 'ArrowRight') {
        this.goRight();
      }
    },
    setEmployeeJourney(employeeJourney) {
      this.selectedEmployeeJourney = employeeJourney;
      if (this.questionOptions && Array.isArray(this.questionOptions) && this.questionOptions.length > 0) {
        this.selectedQuestion = this.questionOptions[0];
      } else {
        this.selectedQuestion = null;
      }
    },
    setPage(page) {
      this.curr = page;
    },
    async createImageURLs() {
      for (let slide of this.slides) {
        for (let item of slide.content) {
          if (item.type === 'image') {
            let response = await axios.get(`survey/retrieveFile/${this.id}/${item.content}`, {
              params : {"secretKey" : this.secret},
              responseType: 'blob',
              headers: { Authorization: accessToken() }
            });
            item.imageUrl = URL.createObjectURL(response.data);
          }
        }
      }
    },
    transposeTable() {
      // Extract column names
      this.columns = Object.keys(this.tableData[0]);

      // Transpose the table data
      this.transposedData = this.columns.map((column) => {
        const rowData = { [column]: [] };
        this.tableData.forEach((item) => {
          rowData[column].push(item[column]);
        });
        return rowData;
      })
    },
  processComparisonPages() {
      // 차수비교와 관련 있는 슬라이드들을 하나의 comparisonPages에 넣는다
      for (let slide of this.slides) {
        if (!slide.category) continue;

        // TODO: 직원성향 테이블 두 개를 하나로 병합하는 로직. 추후에 송일수 대리님과 논의하여 백엔드에서 하나의 테이블에 대한 정보만 보낼 수 있도록 수정하는 것이 필요해 보임.
        if (slide.category === '직원성향') {
          mergeOverallTendencyData(slide);
        } else if (slide.option === '직원성향') {
          mergeEmployeeJourneyTendencyData(slide);
        }
      }
    }
  },
  async mounted() {
    try {
      this.loading = true;

      // Retrieve survey details
      let url = "survey/selectSurveyDetail";
      let data = { 
        surveyId: this.id,
        secretKey: this.secret
      };
      let config = { headers: { Authorization: accessToken() } };
      let response = await axios.post(url, data, config);

      this.slides = response.data;
      this.slides.forEach((slide,index)=>{
        if(slide.category!=''&&!this.categoryNav.some((item) => item.category === slide.category)){
          slide.page = index+1;
          this.categoryNav.push(slide);
        }
      })

      await this.createImageURLs();
      this.processComparisonPages();
    } catch (err) {
      this.loading = false;
      this.showMessage('Error occurred while mounting: ' + err.message);
    } finally {
      this.loading = false;
      window.addEventListener('keydown', this.handleArrowKey);
    }
  },
  updated() {
    if (this.selectedEmployeeJourney) return;
    let options = this.employeeJourneyOptions;
    if (options && options.length > 0) {
      this.selectedEmployeeJourney = options[0];
    }
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleArrowKey);
  }
});

function mergeOverallTendencyData(slide) {
  let data = [];
  data =slide.content[1].content.concat(slide.content[3].content);

  slide.content = slide.content.filter(content => content.type !== 'json');
  slide.content.push({ type: 'json', content: data })
}

function mergeEmployeeJourneyTendencyData(slide) {
  let data = [];
  
  slide.content[1].content.map((item, index) => {
  data.push( {
    "구분": item["구분"],
    "결과": item["비율"]+'%',
    "비교 차수 결과": slide.content[2].content[index]["비율"]+'%',
    "증감": (item["비율"]-slide.content[2].content[index]["비율"]).toFixed(2)+'%'
  })
});
  slide.content = slide.content.filter(content => content.type !== 'json');
  slide.content.push({ type: 'json', content: data });
}

</script>

<style>
#survey-visualized button {
    height: inherit !important;
}
</style>

<style scoped>
p {
    margin-bottom: 0;
}

.card {
    max-width: 1600px;
}

.card-body {
    padding: 1rem;
}

.card-footer {
    background-color: white;
}

.arrow {
    position: absolute;
    top: 50%;
    opacity: .4;
}

.arrow:hover {
    opacity: 1;
    cursor: pointer;
}

.arrow-left {
    left: 0;
}

.arrow-right {
    right: 0;
}

img {
    width: 100%;
    max-width: 640px;
    height: auto;
}

.footnote {
    font-size: 1rem;
    padding-left: 3rem;
}

.nav-pills > .nav-item > .active {
    color: rgb(73, 80, 102) !important;
    background-color: lightgray !important;
}

.survey-nav-text {
    font-weight: bold;
    font-size: 1.1em
}

.survey-title {
    font-size: 2rem;
}
</style>